import BrandOrderDetailsPage from "@faire/prototype-playground/workspace/bd/brand-order-details";
import BrandOrderNotesPage from "@faire/prototype-playground/workspace/bd/brand-order-notes";
import BrandPromoOrdersPage from "@faire/prototype-playground/workspace/bd/brand-promo-orders";
import BrandPromoOrdersPromoUnderTotalPage from "@faire/prototype-playground/workspace/bd/brand-promo-orders-promo-under-total";
import CheckoutOrderNotesPage from "@faire/prototype-playground/workspace/bd/checkout-order-notes";
import UnifiedOrderNotesPage from "@faire/prototype-playground/workspace/bd/unified-order-notes";
import { Route, Switch } from "react-router-dom";

export function BrandonDangRoutes() {
  return (
    <Switch>
      <Route
        path="/bd/brand-order-details/:promoVariant?"
        component={BrandOrderDetailsPage}
      />
      <Route path="/bd/brand-order-notes" component={BrandOrderNotesPage} />
      <Route path="/bd/brand-promo-orders" component={BrandPromoOrdersPage} />
      <Route
        path="/bd/brand-promo-orders-promo-under-total"
        component={BrandPromoOrdersPromoUnderTotalPage}
      />
      <Route
        path="/bd/checkout-order-notes"
        component={CheckoutOrderNotesPage}
      />
      <Route path="/bd/unified-order-notes" component={UnifiedOrderNotesPage} />
    </Switch>
  );
}

export const slug = "bd";
